import React from 'react';
import StripeConnect from 'components/stripe/stripeconnect';
import './dashboard.css';

const ConnectStripe = (data) => {
  return <div className='connect-stripe-card'>
    <StripeConnect/>
  </div>
}
export default ConnectStripe;